import type { RootState } from '~/store/store.ts';

export const selectDiia = (state: RootState) => state.diia;
